<template>
  <div>
    <h1>Ugovori</h1>
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-primary" @click="createContract()">
          Novi nalog
        </button>
        <button
          class="btn btn-primary mr-1 ml-1"
          v-if="selected.length > 0"
          @click="editContract"
        >
          Edit
        </button>
        <button
          class="btn btn-primary mr-1 ml-1"
          v-if="selected.length > 0"
          @click="deleteContract"
        >
          Delete
        </button>
      </div>
    </div>
    <div class="row pl-3 pr-3 mt-3">
      <div id="vueapp" class="vue-app" v-if="getContracts.length > 0">
        <v-data-table
          v-model="selected"
          :headers="columns"
          :items="getContracts"
          :single-select="true"
          :sort-by="['startDate', 'endDate']"
          :sort-desc="[true, true]"
          item-key="id"
          show-select
          class="elevation-1"
        >
          <template v-slot:item.id="{ item }">
            <span>{{ item.id }}</span>
          </template>
          <template v-slot:item.startDate="{ item }">
            <span>{{ new Date(item.startDate) | moment }}</span>
          </template>
          <template v-slot:item.endDate="{ item }">
            <span>{{ new Date(item.endDate) | moment }}</span>
          </template>
          <template v-slot:item.expired="{ item }">
            <span
              v-if="item.startDate === item.endDate"
              :style="{ color: 'red' }"
              >Ugovor je istekao</span
            >
            <span
              v-if="
                timeDifference(item.startDate, item.endDate) < 30 &&
                  timeDifference(item.startDate, item.endDate) >= 1
              "
              :style="{ color: 'orange' }"
              >Ugovor je pri isticanju (jos
              {{ timeDifference(item.startDate, item.endDate) }} dana)</span
            >
            <span
              v-if="timeDifference(item.startDate, item.endDate) > 30"
              :style="{ color: 'green' }"
              >Ugovor je vazeci ( jos
              {{ timeDifference(item.startDate, item.endDate) }} dana )</span
            >
          </template>
        </v-data-table>
      </div>
      <div v-else>
        <h2>Trenutno nemamo kreiranih naloga. Kreiraj radni nalog !</h2>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  created() {
    this.$store.dispatch("getAllContracts");
  },
  data() {
    return {
      selected: [],
      columns: [
        {
          value: "id", // create a column bound to the "name" field
          text: "Sifra ugovora"
        },
        {
          value: "comapnySelected",
          text: "Klijent"
        },
        {
          value: "startDate",
          text: "Datum potpisivanja ugovora"
        },
        {
          value: "endDate",
          text: "Datum isteka ugovora"
        },
        {
          value: "expired",
          text: "Status ugovora"
        }
      ]
    };
  },
  methods: {
    createContract() {
      this.$router.push("/contracts-create");
    },
    editContract() {
      this.$router.push({
        name: "contracts-edit",
        params: { data: this.selected, editMode: true }
      });
    },
    deleteContract() {
      const contractId = this.selected[0].id;
      if (!contractId) return;
      this.$store.dispatch("deleteContract", contractId);
    },
    /*eslint-disable*/
    timeDifference(date1, date2) {
      var c = moment(date2).diff(moment(date1), "days");
      return c;
    }
  },
  computed: {
    getContracts() {
      return this.$store.getters.getContracts;
    }
  },
  filters: {
    moment: function(date) {
      return moment(date).format("DD-MM-YYYY");
    }
  }
};
</script>

<style></style>
